// code custom js pour fiche produit Tables Added By Ader
document.addEventListener('DOMContentLoaded', function () {
  const infosProduct = document.getElementById('infos_product');
  const imageDimension = document.querySelector('.image_dimension');

  const productInfo = document.querySelector('.product-info');

  // Si l'élément existe et on est sur mobile
  if (infosProduct && productInfo && window.innerWidth <= 768) {
    productInfo.appendChild(infosProduct); // Déplace à la fin
    productInfo.appendChild(imageDimension); // Déplace à la fin
  }
});

// Son "cha-ching" à l'ajout au panier
(function () {
  var cartAddSound = new Audio('https://cdn.shopify.com/s/files/1/0682/4329/2390/files/shopify_sale_sound.mp3?v=1783022836');
  cartAddSound.preload = 'auto';

  document.addEventListener('variant:add', function () {
    try {
      cartAddSound.currentTime = 0;
      cartAddSound.play();
    } catch (e) {
      /* silencieux si le navigateur bloque la lecture automatique */
    }
  });
})();
